import { createSlice } from '@reduxjs/toolkit'

interface WishlistModalState {
  isOpen: boolean
}

const initialState: WishlistModalState = {
  isOpen: false,
}

const wishlistModalSlice = createSlice({
  name: 'wishlistModal',
  initialState,
  reducers: {
    openWishlistModal: state => {
      state.isOpen = true
    },
    closeWishlistModal: state => {
      state.isOpen = false
    },
  },
})

export const { openWishlistModal, closeWishlistModal } = wishlistModalSlice.actions
export const selectWishlistModalIsOpen = (state: { wishlistModal: WishlistModalState }) =>
  state.wishlistModal.isOpen

export default wishlistModalSlice.reducer
